<div class="plans-container">
  <p-confirmDialog [style]="{minWidth: '400px'}" />

  @if (isLoading()) {
    <div class="loading-container">
      <p-progressSpinner class="loading-spinner"></p-progressSpinner>
      <p i18n="@@plans.loading">Loading billing data...</p>
    </div>
  } @else {
    <div class="plans-grid">
      @for (plan of plans(); track plan.code) {
        <app-plan-card
          [plan]="plan"
          [isCurrent]="isCurrentPlan(plan)"
          [isLoading]="isChangingSubscription()"
          (subscribe)="onSubscribe($event)"
          (cancel)="onCancel($event)"
        />
      }
    </div>
  }
</div>
